import { render, staticRenderFns } from "./Tentang.vue?vue&type=template&id=05a662d8&"
import script from "./Tentang.vue?vue&type=script&lang=js&"
export * from "./Tentang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports